import { DndContext, closestCenter, DragEndEvent } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { AccSkillsType } from 'builder/modules/sevenStories'

import ReviewSkill from '../ReviewSkill'
import { SkillsContainer } from '../../styles'

type Props = {
  flag: boolean
  isSelectionAllowed: boolean
  accomplishmentsSkills: AccSkillsType[]
  handleSelect: (id: number, storyID: number) => void
  handleSortEnd: (oldIndex: number, newIndex: number) => void
}

const DroppableWrapper = ({
  flag,
  handleSelect,
  handleSortEnd,
  isSelectionAllowed,
  accomplishmentsSkills,
}: Props) => {
  const onSortEnd = ({ active, over }: DragEndEvent) => {
    if (!over || active.id === over.id) return

    const oldIndex = accomplishmentsSkills.findIndex(item => item.id === active.id)
    const newIndex = accomplishmentsSkills.findIndex(item => item.id === over.id)

    handleSortEnd(oldIndex, newIndex)
  }

  return (
    <DndContext onDragEnd={onSortEnd} collisionDetection={closestCenter}>
      <SortableContext items={accomplishmentsSkills} strategy={verticalListSortingStrategy}>
        <SkillsContainer>
          {accomplishmentsSkills
            .filter(skill => skill.isSelected === flag)
            .map(({ id, text, storyID, isSelected }, index) => (
              <ReviewSkill
                key={id}
                {...{
                  id,
                  text,
                  index,
                  storyID,
                  isSelected,
                  handleSelect,
                  isSelectionAllowed,
                }}
              />
            ))}
        </SkillsContainer>
      </SortableContext>
    </DndContext>
  )
}

export default DroppableWrapper
